import { useTranslation } from "react-i18next";
import ThresholdMap, { NEW_DB_TILE_BASE_PATH } from "../../maps/ThresholdMap";
import { Grid } from "@mantine/core";
import GrayScaleMap from "../../gray_scale_map/GrayScaleMap";

export default function BaselineMaps(props) {
  const { t } = useTranslation();

  return (
    <Grid px={!props.halfMaps && "md"}>
      <Grid.Col span={props.halfMaps ? 6 : 3}>
        <GrayScaleMap input={props.thresholds} testType={props.type} eye={props.eye} />
      </Grid.Col>
      {!props.halfMaps && (
        <Grid.Col span={3}>
          <ThresholdMap thresholds={props.thresholds} testType={props.type} eye={props.eye} />
        </Grid.Col>
      )}
      {!props.halfMaps && (
        <Grid.Col span={3}>
          <ThresholdMap
            thresholds={props.ntdGs}
            testType={props.type}
            eye={props.eye}
            checkEmptyCells={true}
            content="probabilityTile"
            probabilityTileBasePath={NEW_DB_TILE_BASE_PATH}
          />
        </Grid.Col>
      )}
      <Grid.Col span={props.halfMaps ? 6 : 3}>
        <div>
          {props.meanDeviation < -20 ? (
            <div className={"depressed-field-warning"}>{t("severely_depressed_field_warning")}</div>
          ) : (
            <ThresholdMap
              thresholds={props.npdGs}
              testType={props.type}
              eye={props.eye}
              checkEmptyCells={true}
              content="probabilityTile"
              probabilityTileBasePath={NEW_DB_TILE_BASE_PATH}
            />
          )}
        </div>
      </Grid.Col>
    </Grid>
  );
}
